import React from 'react';
import { Breakpoint, Button, Fab, useMediaQuery, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface NewButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  breakpoint?: Breakpoint;
  text?: string;
  sx?: React.CSSProperties;
  disabled?: boolean;
  icon?: React.ReactNode;
  fixedPosition?: boolean;
  color?: any;
}

export const NewButton: React.FC<NewButtonProps> = ({ 
  onClick,
  breakpoint, 
  text, 
  sx, 
  disabled, 
  icon = <AddIcon />,
  fixedPosition = true,
  color,
}) => {
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down(breakpoint ?? 'sm'));

  const positionSx = fixedPosition ? {
    position: 'fixed',
    bottom: 16,
    right: 16,
  } : {};
  
  if (small) {
    return (
      <Fab
        color={color ?? "primary"}
        aria-label={text}
        onClick={onClick}
        sx={{
          ...positionSx,
          ...sx,
          backgroundColor: color ?? "primary"
        }}
      >
        {icon}
      </Fab>
    );
  }

  return (
    <Button
      variant="contained"
      startIcon={icon}
      onClick={onClick}
      color={color ?? "primary"}
      disabled={disabled}
      sx={{
        ...positionSx,
        height: 55,
        ...sx,
        backgroundColor: color ?? "primary"
      }}
    >
      {text}
    </Button>
  );
};
